import { createSelector } from '@ngrx/store';

import { selectEnabledStates, selectLoading, controlRoomFeature } from './control-room.feature';
import { ControlType } from '../models/control-room-models';

export const selectEnabledStateByType = (type: ControlType) =>
  createSelector(selectEnabledStates, (enabledStates) => enabledStates[type] || false);

export const selectLoadingByType = (type: ControlType) =>
  createSelector(selectLoading, (loading) => loading[type] || false);

export const selectLastAutomaticAdviceCustomersPreferencesUpdate =
  controlRoomFeature.selectLastAutomaticAdviceCustomersPreferencesUpdate;
